import { render } from "./NavBarSmallScreen.vue?vue&type=template&id=ee4630d0"
import script from "./NavBarSmallScreen.vue?vue&type=script&lang=js"
export * from "./NavBarSmallScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__